import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { SearchState } from './types';

export const getters: GetterTree<SearchState, RootState> = {};
